import type { CurrentPrice, DayPricesResponse, ApiError } from '@/types';

const API_BASE = '/api';

async function fetchJson<T>(url: string, signal?: AbortSignal): Promise<T> {
  const response = await fetch(url, { signal });

  if (!response.ok) {
    const error: ApiError = await response.json().catch(() => ({
      error: `Request failed with status ${response.status}`,
    }));
    throw error;
  }

  return response.json();
}

export async function getCurrentPrices(signal?: AbortSignal): Promise<CurrentPrice[]> {
  return fetchJson<CurrentPrice[]>(`${API_BASE}/prices/current`, signal);
}

export async function getLatestPrices(area: string, signal?: AbortSignal): Promise<DayPricesResponse> {
  return fetchJson<DayPricesResponse>(`${API_BASE}/prices/${area}/latest`, signal);
}

export async function getTomorrowPrices(area: string, signal?: AbortSignal): Promise<DayPricesResponse> {
  return fetchJson<DayPricesResponse>(`${API_BASE}/prices/${area}/tomorrow`, signal);
}

export async function getPricesByDate(area: string, date: string, signal?: AbortSignal): Promise<DayPricesResponse> {
  return fetchJson<DayPricesResponse>(`${API_BASE}/prices/${area}/${date}`, signal);
}
